export default "__VITE_ASSET__JzB45BHV__"